// Small optional card for GUEST sessions (issue links opened without a
// BidLight account): the person's name and email are already known from
// the invitation, so nothing blocks the page - about 30 s in we ask,
// once, for company and phone (both optional). Big X / "Not now" dismisses
// for the session. Saves via PUT /issue/guest/me.
import React, { useEffect, useState } from "react";
import { Button, Input, Modal, message } from "antd";
import { url } from "api";
import { getGuestToken } from "api/issue/issueApi";

const KEY = "bl_guest_profile_nudge_done";
const DELAY_MS = 30 * 1000;

export default function GuestProfileNudge({ guest, onSaved }) {
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState(guest?.phone || "");
  const [saving, setSaving] = useState(false);
  const token = getGuestToken();
  const missing = guest && !guest.phone; // company is known from the partner - only ask for a phone
  useEffect(() => {
    if (!token || !guest?.email || !missing) return undefined;
    if (sessionStorage.getItem(KEY) === guest.email) return undefined;
    const t = setTimeout(() => setOpen(true), DELAY_MS);
    return () => clearTimeout(t);
  }, [token, guest?.email, missing]); // eslint-disable-line
  const dismiss = () => { try { sessionStorage.setItem(KEY, guest?.email || "1"); } catch { /* ignore */ } setOpen(false); };
  const save = async () => {
    setSaving(true);
    try {
      const resp = await fetch(`${url}/issue/guest/me`, {
        method: "PUT", headers: { "Content-Type": "application/json", "x-guest-token": token },
        body: JSON.stringify({ phone: phone.trim() }),
      });
      const body = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(body.err || "Could not save");
      message.success("Thanks, saved");
      onSaved && onSaved(body.guest);
      dismiss();
    } catch (e) {
      message.error(e.message || "Could not save");
    } finally {
      setSaving(false);
    }
  };
  if (!token || !guest?.email) return null;
  return (
    <Modal open={open} onCancel={dismiss} footer={null} width={360} mask={false} maskClosable
           style={{ top: 72, right: 24, position: "absolute", margin: 0 }} zIndex={2000}
           closeIcon={<span style={{ fontSize: 26, lineHeight: "26px", fontWeight: 700, color: "#111827" }}>×</span>}
           bodyStyle={{ padding: "18px 20px 14px" }}>
      <div style={{ fontWeight: 700, color: "#111827", marginBottom: 4, paddingRight: 24 }}>One more thing?</div>
      <div style={{ fontSize: 12.5, color: "#6b7280", marginBottom: 10 }}>
        You are in as <b>{guest.name || guest.email}</b>{guest.company ? <> at <b>{guest.company}</b></> : null} ({guest.email}). If you like, add a phone number so the team can reach you. Optional.
      </div>
      <Input placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} onPressEnter={save} style={{ marginBottom: 10 }} />
      <div style={{ display: "flex", gap: 8 }}>
        <Button size="small" onClick={dismiss}>Not now</Button>
        <Button size="small" type="primary" onClick={save} loading={saving} style={{ flex: 1 }}>Save</Button>
      </div>
    </Modal>
  );
}
